import React, { useEffect } from 'react';
import EnhancedHero from '../components/EnhancedHero';
import FeaturesSection from '../components/FeaturesSection';
import CtaSection from '../components/CtaSection';
import PartnersSection from '../components/PartnersSection';
import IndustriesSection from '../components/IndustriesSection';
import ProductShowcaseSection from '../components/ProductShowcaseSection';
import WhyChooseUsSection from '../components/WhyChooseUsSection';
import '../styles/modern.css';

const ModernHomePage = () => {
  useEffect(() => {
    // Enable smooth scrolling for page
    document.documentElement.style.scrollBehavior = 'smooth';
    
    // Initialize animations
    const fadeElems = document.querySelectorAll('.fade-in');
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('active');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });
    
    fadeElems.forEach(elem => observer.observe(elem));
    
    return () => {
      fadeElems.forEach(elem => observer.unobserve(elem));
    };
  }, []);

  // Scroll to top on page load
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  
  return (
    <div className="modern-site">
      <EnhancedHero />
      <PartnersSection />
      <FeaturesSection />
      <ProductShowcaseSection />
      <WhyChooseUsSection />
      <IndustriesSection />
      <CtaSection />
    </div>
  );
};

export default ModernHomePage;
